"use client";

import { Route } from "@faire/web-api/Route";
import { props as signUpRouteProps } from "@faire/web-api/routes/welcome/r";
import React from "react";
import { useLocation } from "react-router-dom";

import { useIsSignupRevamp } from "@faire/retailer/lib/signUpRevampUtils";
import { LazySignUpRoot } from "@faire/retailer/views/SignUp";
import { LazySignUpRoot as LazyForkedSignUpRoot } from "@faire/retailer/views/SignUp/__forked__";

export const RenderRetailerSignUp = () => {
  const location = useLocation();
  const isSignupRevamp = useIsSignupRevamp(location);

  return (
    <Route
      {...signUpRouteProps}
      render={() => {
        if (isSignupRevamp) {
          return <LazyForkedSignUpRoot />;
        }
        return <LazySignUpRoot />;
      }}
    />
  );
};
